import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Button, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import Cookies from 'js-cookie';

const Profile = () => {
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [profileData, setProfileData] = useState(null);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    // Ensure new and confirm passwords match
    if (newPassword !== confirmPassword) {
      alert('New passwords do not match');
      return;
    }

    const data = {
      userId: Cookies.get('id'),
      previousPassword: currentPassword,
      newPassword: newPassword
    };

    try {
      const response = await axios.put('https://backend.writerswright.com/api/v1/student/updatepassword', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log(response.data); // Log response for debugging
      alert('Password updated successfully.');
      // Optionally clear the form or update state
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      handlePasswordModalClose();
    } catch (error) {
      console.error('Error updating password:', error);
      alert('Failed to update password. Please check the server logs.');
    }
  };

  const handleResize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Fetch profile data from the API
    axios.get('https://backend.writerswright.com/api/v1/admin/getAdminProfile')
      .then(response => {
        setProfileData(response.data);
      })
      .catch(error => {
        console.error('Error fetching profile data:', error);
      });
  }, []);

  const handleProfileModalShow = () => setShowProfileModal(true);
  const handleProfileModalClose = () => setShowProfileModal(false);

  const handlePasswordModalShow = () => setShowPasswordModal(true);
  const handlePasswordModalClose = () => setShowPasswordModal(false);

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    console.log('Profile form submitted');
  };


  return (
    <Container>
      <h4 className="title">Profile</h4>
      <div
        style={{
          width: isMobile ? '90%' : '60%',
          height: '100%',
          margin: 'auto',
          borderRadius: '10px',
          marginBottom: '10px',
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
          padding: '5% 10%',
        }}
      >
        {profileData && (
          <Row>
            <Col lg={6} md={6} sm={12}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Name</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Name} {profileData.Surname}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Username</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Username || 'N/A'}</div>
            </Col>

            <Col lg={6} md={6} sm={12}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Email:</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Email}</div>
            </Col>

            <Col lg={4} md={4} sm={12} className="d-flex justify-content-center align-items-center" style={{ height: 'auto' }}>
              {/* Uncomment and use if you have a profile picture URL */}
              {/* <img
                src={`https://backend.writerswright.com/${profileData.ProfilePicture}`}
                alt="Profile"
                className="img-circle"
                style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              /> */}
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            {/* Uncomment the button if you have an update profile functionality */}
            {/* <button className='button-37' onClick={handleProfileModalShow} style={{ marginRight: '5px', marginTop: '5px' }}>Update Profile</button> */}
            <button className='button-37' onClick={handlePasswordModalShow} style={{ marginTop: '5px' }}>Update Password</button>
          </Col>
        </Row>
      </div>

      {/* Update Profile Modal */}
      <Modal show={showProfileModal} onHide={handleProfileModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleProfileSubmit}>
            <Form.Group controlId="formProfileImage">
              <Form.Label>Profile Image</Form.Label>
              <Form.Control type="file" />
            </Form.Group>
            <Form.Group controlId="formProfileName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter name" />
            </Form.Group>
            <Form.Group controlId="formProfileEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
            </Form.Group>
            <Form.Group controlId="formProfileContact">
              <Form.Label>Contact</Form.Label>
              <Form.Control type="text" placeholder="Enter contact number" />
            </Form.Group>
            <button className='button-37 mt-2' type="submit">Update Profile</button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Update Password Modal */}
      <Modal show={showPasswordModal} onHide={handlePasswordModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form onSubmit={handlePasswordSubmit}>
            <Form.Group controlId="formOldPassword">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter current password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formNewPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formConfirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
            <button className="button-37 mt-2" type="submit" style={{ marginRight: '5px' }}>
              Update Password
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Profile;
